export default [
  {
    path: '/attachments',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "attachments-list" */ "@/views/attachments/List.vue"),
  },
]
